var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "1 1 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82109 7.07178H7.65234V14.0843H8.82109V7.07178Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3289 7.07178H11.1602V14.0843H12.3289V7.07178Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56094 3.56543C3.2382 3.56543 2.97656 3.82706 2.97656 4.1498C2.97656 4.47255 3.2382 4.73418 3.56094 4.73418H4.14531V16.4217C4.14531 16.7317 4.26845 17.0289 4.48763 17.2481C4.70681 17.4673 5.00409 17.5904 5.31406 17.5904H14.6641C14.974 17.5904 15.2713 17.4673 15.4905 17.2481C15.7097 17.0289 15.8328 16.7317 15.8328 16.4217V4.73418H16.4172C16.7399 4.73418 17.0016 4.47255 17.0016 4.1498C17.0016 3.82706 16.7399 3.56543 16.4172 3.56543H3.56094ZM5.31406 16.4217V4.73418H14.6641V16.4217H5.31406Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.743 1.22803H8.23672C7.91398 1.22803 7.65234 1.48966 7.65234 1.8124C7.65234 2.13514 7.91398 2.39678 8.23672 2.39678H11.743C12.0657 2.39678 12.3273 2.13514 12.3273 1.8124C12.3273 1.48966 12.0657 1.22803 11.743 1.22803Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/RemoveIcon.e8cf176a.svg";
export { ForwardRef as ReactComponent };